import api from "../../store/services/api";

class DeliveryReportService {
  getPrimaryInfo = (params) => {
    return api.get("/orders/report/delivery/", { params });
  };
  getMerchantByDeliveryTax = (params) => {
    return api.get("/merchant/report/delivery-tax/", { params });
  };
}

export default new DeliveryReportService();
